__webpack_require__.p = "https://certificate.quantstamp.com/full/solv-protocol-btc-redemption/a64fb510-0ecb-4c98-8dd5-4a72a9506329/";